import React, { useState } from "react";
import "./styles.scss";
import { FreeTrialTutorsModal } from "@/components/FreeTrialTutorsModal";
import { useGetItemsQuery } from "@/services/apiSlice/utilitySlice";

export const TrialCard = ({
  freeTrial,
  isLoading,
}: {
  isLoading: boolean;
  freeTrial: {
    content: {
      description: string;
      title: string;
      cta: { label: string };
    };
  }[];
}) => {
  const [open, setOpen] = useState(false);

  const {
    data: freeTrialTutor,
    isLoading: tutorLoading,
    isError: tutorError,
  } = useGetItemsQuery("/teachers/trail-lessons/get-teachers");

  const teacher = freeTrialTutor?.result;

  return freeTrial?.length < 1 ? null : (
    <div className="trial-card-container">
      <img
        alt="trial-card"
        className="trial-card-container__image-container"
        src={require("@/assets/trial-card.png")}
      />

      {tutorLoading || isLoading ? (
        <>
          <div className="trial-card-container__skeleton trial-card-container__skeleton--title" />
          <div className="trial-card-container__skeleton trial-card-container__skeleton--subtitle" />
          <div className="trial-card-container__skeleton trial-card-container__skeleton--button" />
        </>
      ) : !Array.isArray(freeTrial) || freeTrial.length === 0 ? null : (
        <>
          <h4 className="trial-card-container__title">
            {freeTrial[0]?.content?.title || ""}
          </h4>

          <h2 className="trial-card-container__subtitle">
            {freeTrial?.[0]?.content?.title || ""}
          </h2>

          <button
            className="trial-card-container__button"
            onClick={() => !tutorLoading && setOpen(true)}
            disabled={tutorLoading}
          >
            <div className="trial-card-container__blur">
              <span className="trial-card-container__button-text">
                {freeTrial?.[0]?.content?.cta?.label || ""}
              </span>
            </div>
          </button>
        </>
      )}

      <FreeTrialTutorsModal
        visible={open}
        onClose={() => setOpen(false)}
        teachers={teacher}
      />
    </div>
  );
};
